<template>
  <div class="audience-hub-dashboard">
    <dashboard-header></dashboard-header>
    <audience-hub-table
      @targetOption="handleTargetOption"
      :filters="query"
      :routeParamsName="routeParamsName"
    ></audience-hub-table>
    <div>
      <dashboard-action-modal :target="activeTarget" buttonText="Delete" @click="deleteTarget" ref="deleteModal">
        Are you sure you want to delete target <span class="audience-hub-dashboard__delete-target-name">{{ activeTarget.display_name }}?</span>
      </dashboard-action-modal>
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/appComponents/common/AudienceHubDashboardHeader'
import AudienceHubTable from '@/appComponents/audienceHubDashboard/AudienceHubTable'
import DashboardActionModal from '@/appComponents/audienceHubDashboard/DashboardActionModal'
import { targetRouteHandler } from '@/helpers'

export default {
  components: {
    AudienceHubTable,
    DashboardActionModal,
    DashboardHeader
  },
  props: {
    // query is in the router set as a prop on the route
    query: Object
  },
  data () {
    return {
      popover: null,
      activeTarget: {}
    }
  },
  computed: {
    routeParamsName () {
      return this.$route.params.name
    },
    whichTargets () {
      return this.$store.state.targetManager.displayOptions.whichTargets
    },
    username () {
      return this.$store.state.auth.username
    }
  },
  methods: {
    showDeleteModal (target) {
      this.$refs.deleteModal.open(target)
    },
    handleTargetOption (option, target) {
      if (option === 'DELETE') {
        this.handleDelete(target)
        return
      }
      targetRouteHandler(option, target)
    },
    deleteTarget (target) {
      targetRouteHandler('DELETE', target)
    },
    handleDelete (target) {
      this.activeTarget = target
      this.$refs.deleteModal.open()
    },
    newTarget () {
      this.$router.push({ name: 'new-target' })
    }
  }
}

</script>

<style lang="scss">
.audience-hub-dashboard {
  height: 100%;
  width: 100%;

  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 50px calc(100% - 50px);

  grid-template-areas:
    "header"
    "table";

  &__delete-target-name {
    display: block;
    margin-top: 20px;
    color: #232A32;
    font-weight: 700;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// AudienceHubDashboard.vue?61b97d9f